// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* master */
body,
html {
  box-sizing: border-box;
  margin: 0;
  background-color: var(--white_color_100);
  font-size: 18px;
}

.empty_page_wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
  flex-direction: column;
  font-family: 'OpenSans-Regular';
  padding: 0 20px;
  box-sizing: border-box;
  text-align: center;
}

.empty_page_icon {
  width: 45px;
  height: 43px;
  margin-bottom: 30px;
  background-image: url('https://dzfa1uifb0sb6.cloudfront.net/icons/empty_icon.svg');
}

.empty_page_title {
  font-size: 22px;
  margin-bottom: 20px;
  font-weight: 700;
}

.publish_page_body > div,
.publish_page_footer_wrapper {
  max-width: 700px;
  margin: 0 auto;
  font-size: 14px;
}

.publish_page_body {
  padding: 30px 0;
  background-color: #ebecf0;
}

.publish_page_body > div {
  filter: drop-shadow(0px 0px 1px #40576d12) drop-shadow(0px 2px 8px #394c6026);
  position: relative;
}

.publish_page_watermark::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
  background: url(https://dzfa1uifb0sb6.cloudfront.net/icons/gipperlogo_grey_icon.svg);
  background-size: 60%;
  background-repeat: repeat-y;
  background-position-x: center;
  opacity: 30%;
}

.logo_link {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
  text-decoration: none;
  color: #15151e;
}

.gipper_logo {
  width: 111px;
}

.button_component_body[data-button-url='no_link'] {
  pointer-events: none;
}

@media (max-width: 700px) {
  .publish_page_body {
    padding: 0 0 30px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,WAAW;AACX;;EAEE,sBAAsB;EACtB,SAAS;EACT,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kFAAkF;AACpF;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6EAA6E;EAC7E,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,UAAU;EACV,oFAAoF;EACpF,oBAAoB;EACpB,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* master */\nbody,\nhtml {\n  box-sizing: border-box;\n  margin: 0;\n  background-color: var(--white_color_100);\n  font-size: 18px;\n}\n\n.empty_page_wrapper {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  flex-direction: column;\n  font-family: 'OpenSans-Regular';\n  padding: 0 20px;\n  box-sizing: border-box;\n  text-align: center;\n}\n\n.empty_page_icon {\n  width: 45px;\n  height: 43px;\n  margin-bottom: 30px;\n  background-image: url('https://dzfa1uifb0sb6.cloudfront.net/icons/empty_icon.svg');\n}\n\n.empty_page_title {\n  font-size: 22px;\n  margin-bottom: 20px;\n  font-weight: 700;\n}\n\n.publish_page_body > div,\n.publish_page_footer_wrapper {\n  max-width: 700px;\n  margin: 0 auto;\n  font-size: 14px;\n}\n\n.publish_page_body {\n  padding: 30px 0;\n  background-color: #ebecf0;\n}\n\n.publish_page_body > div {\n  filter: drop-shadow(0px 0px 1px #40576d12) drop-shadow(0px 2px 8px #394c6026);\n  position: relative;\n}\n\n.publish_page_watermark::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n  background: url(https://dzfa1uifb0sb6.cloudfront.net/icons/gipperlogo_grey_icon.svg);\n  background-size: 60%;\n  background-repeat: repeat-y;\n  background-position-x: center;\n  opacity: 30%;\n}\n\n.logo_link {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  gap: 10px;\n  text-decoration: none;\n  color: #15151e;\n}\n\n.gipper_logo {\n  width: 111px;\n}\n\n.button_component_body[data-button-url='no_link'] {\n  pointer-events: none;\n}\n\n@media (max-width: 700px) {\n  .publish_page_body {\n    padding: 0 0 30px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
